import importerSelectors from '../../../modules/shared/importer/importerSelectors'

const categoryCourseRelationImporterSelectors =
  importerSelectors('categoryCourseRelation.importer')

export default categoryCourseRelationImporterSelectors
